import { HORIZONTAL_TEMPLATE, OUTDATED_TEMPLATE, VERTICAL_TEMPLATE } from '@anm/constants/videoLandings';

var getLandingTemplate = function getLandingTemplate(template, sizes, ratio) {
  if (template !== OUTDATED_TEMPLATE || !sizes) return template;
  return ratio || sizes.width / sizes.height > 1 ? HORIZONTAL_TEMPLATE : VERTICAL_TEMPLATE;
};

export default getLandingTemplate;